import { render } from "./multiLanguage.vue?vue&type=template&id=5ad5a452"
import script from "./multiLanguage.vue?vue&type=script&lang=js"
export * from "./multiLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__